<template>
<div class="pageBawTransfer" id="">  
  <div class="xr-mingxi">
    <mu-appbar class="xr-head" title="BAW转账">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
      <!-- <router-link  slot="right" to="/usercenter/coinStream">
          <p>明细</p>
      </router-link> -->
    </mu-appbar>
  </div>

  <mu-list>
    <mu-list-item disableRipple title="" describeText="">
        <mu-text-field label="手机号" fullWidth :disabled="true" v-model="mobile" />
      <mu-icon value=":fa fa-phone" slot="leftAvatar" size="30" style="margin-top:60px;margin-left:-2px" />
    </mu-list-item>
    <mu-list-item disableRipple title="" describeText="">      
      <mu-row gutter>
        <mu-col width="70" tablet="75" desktop="33">
          <mu-text-field label="短信验证码" helpText="点击右侧按钮获取" v-model="transfer.code" icon=":fa fa-envelope-o" labelFloat fullWidth />
        </mu-col>
        <mu-col width="30" tablet="25" desktop="33">      
          <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary />   
        </mu-col>
      </mu-row>
    </mu-list-item>
    <mu-list-item disableRipple title="" describeText="">
      <mu-text-field label="转账个数" helpText="转账的BAW个数" type="number" iconClass="withdrawMoneyText" fullWidth v-model="transfer.Money" />
      <mu-avatar src="/static/BAW/baw.png" slot="leftAvatar" size="30" style="margin-top:60px;margin-left:-2px" />
    </mu-list-item>
    <mu-list-item disableRipple title="" describeText="">
        <mu-text-field label="收款人钱包地址" fullWidth v-model="transfer.ReceivingName" />
      <mu-icon value=":fa fa-member2" slot="leftAvatar" size="30" style="margin-top:60px;margin-left:-2px" />
    </mu-list-item>
    <mu-list-item disableRipple title="" describeText="">
        <mu-text-field label="捎句话" fullWidth v-model="transfer.memo" />
      <mu-icon value=":fa fa-text" slot="leftAvatar" size="30" style="margin-top:60px;margin-left:-2px" />
    </mu-list-item>
  </mu-list>

  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="确认转账" class="demo-raised-button" primary fullWidth @click="submit()" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast @onClose="GoHistory" ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
</div>
</template>
<script>
import {ErrorCode} from '../../../../util/errorcode'
import md5 from 'js-md5'
export default {
  data () {
    return {
      transfer:{},
      
      mobile:'',
      smsBtnText : '获取短信'
    }
  },
  mounted(){    
    this.getMemberInfo()
  },
  computed:{
    transferMoney(){
      return this.transfer.Money?this.transfer.Money:0.00
    }
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.mobile=res.Data.mobile
        }
      });      
    },
    submit:function(){
      this.$refs.XRtoast.load("请稍候...")
      if(!this.transfer.code){
        this.$refs.XRtoast.failed("请输入验证码",true)    
        return
      }
      if(!this.transfer.Money || this.transfer.Money<=0){
        this.$refs.XRtoast.failed("请输入转账个数",true)    
        return
      }
      const ths = this;
      this.$post('/Shop/BawServer/BawTransfer', JSON.stringify(this.transfer))
        .then(function (res) {
          ths.$refs.XRtoast.hide()
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg,true) 
            if(res.TypeId == ErrorCode.SessionMissing){
              ths.$router.push("/Login")
            }
          }
          else{
            ths.$refs.XRtoast.success(res.Msg,true) 
          }   
        })
        .catch(function (err) {
          console.log(err)
        })    
    },
    getSmsCode: function(){
      var ths = this;   
      ths.$post(
        "/Shop/BawServer/BawTransferSendSms"
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{          
          ths.smsBtnText = res.Data * 60;
          var interval = setInterval(function(){
            if(ths.smsBtnText >0){
              ths.smsBtnText--
            }else{
              ths.smsBtnText = '获取短信'
              clearInterval(interval)
            }
          }, 1000)  
        }
      });
    },
    GoHistory(){
      this.$router.goBack()
    }
  }
}

</script>
<style>
#app .pageBawTransfer{
  background: white;
}
.pageBawTransfer .login-form {
  padding: 10px 20px 20px 10px;
}
.pageBawTransfer .login-div {
  padding: 40px 0px 0 20px;
}
.pageBawTransfer .demo-raised-button {
  height: 50px;
}
.pageBawTransfer .div2 {
  padding: 20px 0 0 0;
}
.pageBawTransfer .demo-flat-button.right {
  float: right;
}
.pageBawTransfer .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.pageBawTransfer .pageBawTransfer .notice{
  font-size: 12px;
}
.pageBawTransfer .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}

.pagecoinRechargePayPopup{
  width: 100%;
}
.pagecoinRechargePayPopup .title{
  font-size: 16px;
  text-align: center;
}
.pagecoinRechargePayPopup .rechargeResult{
  font-size: 14px;
  text-align: center;
  padding-top: 20px;
}
.pagecoinRechargePayPopup .submit{
  height: 50px;
}

.pageBawTransfer .xr-mingxi .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.pageBawTransfer .xr-mingxi .mu-appbar-title {
  font-size: 16px;
}
.pageBawTransfer .xr-mingxi .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.pageBawTransfer .xr-mingxi .title .title-text {
  margin: 0;
  line-height: 48px;
}
.pageBawTransfer .xr-mingxi .right{
  margin: 0 8px;
  font-size: 16px
}
.pageBawTransfer .xr-mingxi .right a{
  color: #fff;
}
.pageBawTransfer .mu-text-field.has-label .mu-text-field-icon{
  left:0;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/baw/net/bawTransfer.vue